export default "__VITE_ASSET__CmakWOhR__$_?react__"